import React, { useState } from "react";
import { ProductsTableStatusIndicatorIcon } from "../product-status-indicator-icon/products-table-status-indicator-icon.component";
import { withShowIf } from "../../../../../../components/with-show-if/with-show-If.component";
import { StatusBox } from "./products-table-status-indicator.styles";
import { ProductsTableStatusIndicatorProps } from "./products-table-status-indicator.props";
import { getStatusIndicatorTooltip } from "../../types/product-status-indictaor-tooltip.functions";

export const ProductsTableStatusIndicator = withShowIf(
  (props: ProductsTableStatusIndicatorProps) => {
    const [isHovered, setIsHovered] = useState(false);
    const setHoverState = (value: boolean) => () => setIsHovered(value);
    const StatusToolTip = getStatusIndicatorTooltip(props.status);

    return (
      <StatusBox onMouseEnter={setHoverState(true)} onMouseLeave={setHoverState(false)}>
        <StatusToolTip field={props.field} showIf={isHovered} />
        <ProductsTableStatusIndicatorIcon status={props.status} />
      </StatusBox>
    );
  }
);
